export default {
  title: 'Dados do comprador'
}